
import { Button, Flex, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import StringUtils from "../../../../../util/StringUtils";
import { InfoGroup, InfoGroupContent, InfoGroupSeparator, InfoGroupTitle, Parameter, ParameterGroup, ParameterGroupContent, ParameterGroupTitle, ParameterName, ParameterValue, ProductBasicInformationWrapper, ProductDescriptionContent, ProductDescriptionTitle, ProductDescriptionWrapper, ProductModelPicture } from "./ProductBasicInformation.styled";

interface ProductBasicInformationProps {
    product: any
}

export const ProductBasicInformation: React.FC<ProductBasicInformationProps> = (props)=> {
    // params
    let { product } = props;

    // parameter group
    let parameterGroups = [
        {
            name: '物理特性',
            parameters: [
                {
                    name: '产品尺寸',
                    value: product.specification.basic.general.size
                },
                {
                    name: '重量',
                    value: product.specification.basic.general.weight
                },
                {
                    name: '安装方式',
                    value: product.specification.basic.general.installationMethod
                },
                {
                    name: '工作温度',
                    value: product.specification.basic.general.workingTemperature
                },
                {
                    name: '工作湿度',
                    value: product.specification.basic.general.workingHumidity
                },
                {
                    name: '防水等级',
                    value: product.specification.basic.general.waterproofLevel
                },
            ]
        },
        {
            name: '电源参数',
            parameters: [
                {
                    name: '额定电压',
                    value: product.specification.basic.power.supplyVoltage

                },
                {
                    name: '额定电流',
                    value: product.specification.basic.power.ratedCurrent
                },
                {
                    name: '功耗',
                    value: product.specification.basic.power.powerConsumption
                },
                {
                    name: '电源接口',
                    value: product.specification.basic.power.powerInterface
                },
            ]
        },
        {
            name: '无线网络',
            parameters: [
                {
                    name: '网络制式',
                    value: product.specification.basic.mobileNetwork?.networkStandard
                },
                {
                    name: '频段信息',
                    value: product.specification.basic.mobileNetwork?.supportedBands
                },
                {
                    name: '最大数据传输速率',
                    value: product.specification.basic.mobileNetwork?.maxTransferSpeed
                }
            ]
        },
        {
            name: 'GNSS定位',
            parameters: [
                {
                    name: '频段',
                    value: product.specification.basic.gnss?.supportedGnss
                },
                {
                    name: '定位精度',
                    value: product.specification.basic.gnss?.locationAccuracy
                },
            ]
        }, 
        {
            name: 'AI（模拟量采集）',
            parameters: [
                {
                    name: 'AI通道数',
                    value: product.specification.basic.ai?.channelCount
                },
                {
                    name: '采样精度',
                    value: product.specification.basic.ai?.accuracy
                },
                {
                    name: '输入范围',
                    value: product.specification.basic.ai?.inputRange
                }
            ]
        }
    ];

    // render
    return (
        <ProductBasicInformationWrapper>
            <InfoGroup>
                <InfoGroupTitle></InfoGroupTitle>
                <InfoGroupContent>
                    <Flex vertical={false} style={{width: '100%', marginTop: '20px'}}>
                        <ProductModelPicture style={{
                            backgroundImage: `url(/static/images/product-model/${product.model.toLowerCase()}/model.jpg)`
                        }} />

                        <ProductDescriptionWrapper>
                            <ProductDescriptionTitle>产品简介</ProductDescriptionTitle>
                            <ProductDescriptionContent>{product.specification.basic.general.description}</ProductDescriptionContent>
                        </ProductDescriptionWrapper>
                    </Flex>
                </InfoGroupContent>
            </InfoGroup>
            <InfoGroup style={{marginTop: '40px'}}>
                <InfoGroupTitle>参数信息</InfoGroupTitle>
                <InfoGroupContent>
                    {
                        parameterGroups.map((group, index)=> {
                            return <ParameterGroup key={group.name}>
                                <ParameterGroupTitle>{group.name}</ParameterGroupTitle>
                                <ParameterGroupContent>
                                    {
                                        group.parameters.filter((parameter)=> {
                                            if (StringUtils.isEmpty(parameter.value)) {
                                                return false;
                                            }
                                            return true;
                                        }).map((parameter)=> {
                                            let valueLines = parameter.value.split('\n');
                                            return <Parameter key={parameter.name}>
                                                <ParameterName>{parameter.name}</ParameterName>
                                                <ParameterValue>{valueLines.map((e, index)=> {
                                                    return <span>{e} {index == valueLines.length-1 ? null : <br /> }</span>
                                                })}</ParameterValue>
                                            </Parameter>;
                                        })
                                    }
                                </ParameterGroupContent>
                            </ParameterGroup>
                        })
                    }
                </InfoGroupContent>
            </InfoGroup>
        </ProductBasicInformationWrapper>
    )
}

export default ProductBasicInformation;
